module.exports = __webpack_public_path__ + "images/pages/kaitori_bonus_lp/mainvisual-confetti-sp_d42201297c47e616be7b54d664125778.svg";